import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export interface ReportFilterState {
    showStatusReportsOnly: boolean;
}

const initialState: ReportFilterState = {
    showStatusReportsOnly: false
};

const reportFilterSlice = createSlice({
    name: 'reportFilter',
    initialState,
    reducers: {
        setShowStatusReportsOnly: (state, action: PayloadAction<boolean>) => {
            state.showStatusReportsOnly = action.payload;
        },
        toggleStatusReportsFilter: (state) => {
            state.showStatusReportsOnly = !state.showStatusReportsOnly;
        }
    }
});

const reportFilterConfig = {
    key: 'reportFilter',
    storage
};

export const persistedReportFilterReducer = persistReducer(reportFilterConfig, reportFilterSlice.reducer);
export const { setShowStatusReportsOnly, toggleStatusReportsFilter } = reportFilterSlice.actions;
export const reportFilterReducer = reportFilterSlice.reducer;
